var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"text-white-color",attrs:{"small":_vm.small,"type":"submit","color":"success","loading":_vm.loading,"disabled":_vm.disabled}},[_vm._v(" "+_vm._s(_vm.label || _vm.$t("nav_buttons.save"))+" "),_c('v-icon',{attrs:{"dark":"","right":""}},[_vm._v(" mdi-content-save ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }